'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var placeCaretAtEnd = exports.placeCaretAtEnd = function placeCaretAtEnd(el) {
    if (!el) return;
    el.focus();
    if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (typeof document.body.createTextRange !== 'undefined') {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
    }
};

var selectAll = exports.selectAll = function selectAll(el) {
    if (!el) return;
    el.focus();

    if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (typeof document.body.createTextRange !== 'undefined') {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.select();
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/keyboard/contentEditable.js
// module id = 2126
// module chunks = 0